import { TRACKING_PAGE_THEMES } from 'app/models/brand';
import ImageSelection from 'app/models/image_selection';

import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .image-choice': 'changeSelection',
  },

  initialize({ brand }) {
    this.brand = brand;
    this.model = new ImageSelection({
      choices: [
        // can't concat path strings. gulp rev task doesn't find/replace on partial strings
        { option: TRACKING_PAGE_THEMES.THEME1, src: '/assets/images/tracking_page_themes/1.png' },
        { option: TRACKING_PAGE_THEMES.THEME2, src: '/assets/images/tracking_page_themes/2.png' },
      ],
      paramKey: 'theme',
    });
    this.listenTo(this.model, 'change', this.render);
    this.listenTo(this.brand, 'sync', this.setCurrentChoice);
  },

  context() {
    return {
      choices: this.model.choices,
      currentChoice: this.model.get('currentChoice'),
    };
  },

  changeSelection(e) {
    e.preventDefault();
    const img = $(e.currentTarget).find('img');
    this.model.set('currentChoice', {
      option: img.data('option'),
      src: img.attr('src'),
    });
    this.brand.set(this.model.getParams());
  },

  setCurrentChoice() {
    this.model.setCurrentChoice(this.brand.get('theme'));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/brand/image_selector/index.js